import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import {
  addFilters,
  applyFilters,
} from "../../store/slices/FilterSlicePowerDeck";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownPowerDeck";
import { useQuery } from "@tanstack/react-query";
import {
  fetchRegion,
  fetchStates,
  fetchStatesOffice,
  fetchProductLine,
  fetchLOB,
  reducer,
} from "./apiPowerDeckFilter";

//*------------------COMP----------------------*//
export default function PowerDeckFilter() {
  const { data, submitted } = useSelector((state) => state.filtersPowerDeck);

  const { data: newdata } = useSelector((state) => state.forms);

  const {
    region: pRegion,
    state: pState,
    state_office: pStateOffice,
    Product_Line: pProductLine,
    lob: pLob,
  } = data;

  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(1);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedStateOffice, setSelectedStateOffice] = useState([]);
  const [selectedProductLine, setSelectedProductLine] = useState([]);
  const [selectedLob, setSelectedLOB] = useState([]);

  //* ---------------USE QUERY---------------------/

  const { data: regions, isLoading: rL } = useQuery({
    queryKey: ["region", submitted],
    queryFn: () => fetchRegion(),
    initialData: [],
  });

  const { data: states, isLoading: sL } = useQuery({
    queryKey: ["states", submitted, pRegion],
    queryFn: () => fetchStates(pRegion),
    initialData: [],
  });

  const { data: statesoffice, isLoading: soL } = useQuery({
    queryKey: ["statesoffice", submitted, pRegion, pState],
    queryFn: () => fetchStatesOffice(pRegion, pState),
    initialData: [],
  });

  const { data: productLine, isLoading: plL } = useQuery({
    queryKey: ["productLine", submitted, pRegion, pState, pStateOffice],
    queryFn: () => fetchProductLine(pRegion, pState, pStateOffice),
    initialData: [],
  });

  const { data: lob, isLoading: lobL } = useQuery({
    queryKey: ["lob", submitted, pRegion, pState, pStateOffice, pProductLine],
    queryFn: () =>
      fetchLOB(
        pRegion,
        pState,
        pStateOffice,

        pProductLine,
      ),
    initialData: [],
  });

  async function handleSearch() {
    let userSelectedFilter = {
      data: {
        region: pRegion || selectedRegion,
        state: pState || selectedState,
        state_office: pStateOffice || selectedStateOffice,

        Product_Line: pProductLine || selectedProductLine,
        lob: pLob || selectedLob,
      },
      submitted: clicked + 1,
    };

    dispatch(addFilters(userSelectedFilter));
    setClicked((prev) => prev + 1);
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  // const toggleForm = () => {
  //   setFormVisible(!isFormVisible);
  // };

  //*----------------------JSX-------------------------/
  return (
    <section>
      <div className="rounded-md grid grid-cols-1 md:grid-cols-6 lg:grid-cols-7 gap-3 p-2 items-end">
        <div className={divStyle}>
          <label className={labelStyle}>Region</label>
          <ViMultiSelect
            options={regions}
            onSelectionChange={setSelectedRegion}
            opnsSelected={pRegion}
            keey="region"
            isLoading={rL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>State</label>
          <ViMultiSelect
            options={states}
            onSelectionChange={setSelectedState}
            opnsSelected={pState}
            keey="state"
            isLoading={sL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>State Office</label>
          <ViMultiSelect
            options={statesoffice}
            onSelectionChange={setSelectedStateOffice}
            opnsSelected={pStateOffice}
            keey="state_office"
            isLoading={soL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>Product Line</label>
          <ViMultiSelect
            options={productLine}
            onSelectionChange={setSelectedProductLine}
            opnsSelected={pProductLine}
            keey="Product_Line"
            isLoading={plL}
          />
        </div>

        <div className={divStyle}>
          <label className={labelStyle}>LOB</label>
          <ViMultiSelect
            options={lob}
            onSelectionChange={setSelectedLOB}
            opnsSelected={pLob}
            keey="lob"
            isLoading={lobL}
          />
        </div>

        {/* Apply Button */}
        <div className="flex flex-col justify-end">
          <button
            className="text-white w-full rounded-sm bg-[#2A5775] h-[28px]"
            type="button"
            onClick={handleSearch}
          >
            Apply
          </button>
        </div>

        {/* Reset Button */}
        <div className="flex flex-col justify-end">
          <button
            className="text-white w-full rounded-sm bg-[#2A5775] h-[28px]"
            onClick={handleRefresh}
          >
            Reset
          </button>
        </div>
      </div>
    </section>
  );
}

//*------------------CSS----------------------*//
const divStyle = "flex flex-col  justify-center";
const labelStyle =
  "font-semibold py-1 px-4 text-xs text-[#2A5775] whitespace-nowrap ";
